import { trigger, state, style, transition, animate } from '@angular/animations';
import { Component } from '@angular/core';

@Component({
  selector: 'app-download-application',
  templateUrl: './download-application.component.html',
  styleUrls: ['./download-application.component.scss'],
  animations: [
    trigger('slideOut', [
      state('visible', style({ transform: 'translateX(0)' })),
      state('hidden', style({ transform: 'translateX(100%)' })),
      transition('visible => hidden', animate('300ms ease-out')),
      transition('hidden => visible', animate('300ms ease-in')),
    ]),
  ],
})
export class DownloadApplicationComponent {
  contentVisibility = 'visible';

  ngOnInit() {
    // Check if a value is stored in localStorage
    const storedValue = localStorage.getItem('contentVisibility');

    // Set initial visibility based on the stored value or default to 'visible'
    this.contentVisibility = storedValue === 'hidden' ? 'hidden' : 'visible';
  }

  toggleContentVisibility() {
    // Toggle visibility
    this.contentVisibility = this.contentVisibility === 'visible' ? 'hidden' : 'visible';

    // Store the current visibility state in localStorage
    localStorage.setItem('contentVisibility', this.contentVisibility);
  }
}
